import { render } from "./BlackPatientAddModal.vue?vue&type=template&id=325c3b14&scoped=true"
import script from "./BlackPatientAddModal.vue?vue&type=script&lang=js"
export * from "./BlackPatientAddModal.vue?vue&type=script&lang=js"

import "./BlackPatientAddModal.vue?vue&type=style&index=0&id=325c3b14&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325c3b14"]])

export default __exports__